module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGDRINSECT-09150288e75974b6468f6bae5211842f.png";